import type { ReactNode } from 'react';

export const symbol_screen_rotation_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M604-160H310q-28.87 0-49.44-20.56Q240-201.13 240-230v-344q0-13.5 9.5-21.75t20.65-8.25q11.85 0 20.85 8.78 9 8.78 9 21.22v354h304l-62-62q-5-5-7-10.5t-2-11q0-5.5 2-10.5t6.55-10q5.45-5 10.77-7 5.33-2 11-2 5.68 0 10.68 2t10 7l114 113q5 5 7 10.09t2 10.91q0 5-2 10.5t-7 10.5L584-56q-5 5-10 7t-10.68 2q-5.67 0-11-2Q547-51 542-56t-7-10.5q-2-5.5-2-11t2-10.5q2-5 7-10l62-62Zm116-570v344q0 13.5-9.5 21.75T689.85-356Q678-356 669-364.78q-9-8.78-9-21.22v-354H355l62 62q9 9 9 21.16t-8.61 21Q408-627 395.9-627q-12.1 0-20.9-9L261-749q-5-5-7-10.5t-2-11q0-5.5 2-10.5t7-10l114-113q9-8 21-8.5t21.39 8.5q8.61 9 8.61 21t-9 21l-62 62h295q28.88 0 49.44 20.56T720-730Z"
		/>
	</svg>
);
